// src/app/slices/enclosureSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { deleteAccessory } from './actions';
import { AccessoryState, IEnclosure, IEnclosureParams } from '../models';

const initialState: AccessoryState<IEnclosure, IEnclosureParams> = {
  accessories: {},
  params: null,
};

const enclosureSlice = createSlice({
  name: 'enclosure',
  initialState,
  reducers: {
    setEnclosure: (state, action: PayloadAction<IEnclosure>) => {
      if (!state.accessories[action.payload.section_id])
        state.accessories[action.payload.section_id] = {};
      state.accessories[action.payload.section_id][action.payload.id] =
        action.payload;
    },
    setEnclosureParams: (state, action: PayloadAction<IEnclosureParams>) => {
      state.params = action.payload;
    },
    deleteEnclosure: deleteAccessory,
  },
});

export const { setEnclosure, setEnclosureParams, deleteEnclosure } =
  enclosureSlice.actions;

export default enclosureSlice.reducer;
